import { apiClient } from "./api";
import { Flow, FlowStep } from "../types";

interface ApiOk<T> {
  ok: true;
  data: T;
}

export const flowService = {
  list: (tenantId: string) =>
    apiClient.get<ApiOk<{ flows: Flow[] }>>(
      `/v1/flows?tenantId=${tenantId}`
    ),

  getById: (flowId: string) =>
    apiClient.get<ApiOk<Flow>>(`/v1/flows/${flowId}`),

  create: (body: {
    tenant_id: string;
    name: string;
    description?: string;
    channel?: string;
    first_step_id: string;
    steps: FlowStep[];
    webhook_url?: string;
  }) =>
    apiClient.post<ApiOk<{ id: string }>>("/v1/flows", body),

  update: (
    flowId: string,
    body: Partial<
      Omit<Flow, "id" | "tenant_id" | "created_at" | "updated_at">
    >
  ) =>
    apiClient.patch(`/v1/flows/${flowId}`, body),

  delete: (flowId: string) =>
    apiClient.delete(`/v1/flows/${flowId}`),
};
